


// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import Table from 'react-bootstrap/Table';
// import Navbar from '../../Components/Navbar';
// import Modal from 'react-bootstrap/Modal';
// import Form from 'react-bootstrap/Form';
// import '../Secretary/Table.css';
// import { API_BASE_URL } from '../../config';
// import { Button, Spinner } from "react-bootstrap";

// export default function SendReviewers() {
//   const [applications, setApplications] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [currentApp, setCurrentApp] = useState(null);
//   const [currentReviewer, setCurrentReviewer] = useState({});
//   const [emailBody, setEmailBody] = useState('');
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [fileStatus, setFileStatus] = useState({});
//   const [filteredApplications, setFilteredApplications] = useState([]);
//   const [selectedYear, setSelectedYear] = useState("");

//   const currentYear = new Date().getFullYear();
// const startYear = 2024; // Adjust as needed
// const years = Array.from(
//   { length: currentYear - startYear + 1 },
//   (_, i) => startYear + i
// ).reverse(); // Reverse to show latest years first

//  useEffect(() => {
//   const fetchApplications = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/SendReviewers.php`);
//       console.log('Fetched applications:', response.data);
//       if (Array.isArray(response.data)) {
//         setApplications(response.data);
//         if (selectedYear === "") {
//           setFilteredApplications(response.data); // Show all applications
//         } else {
//           setFilteredApplications(
//             response.data.filter((app) => {
//               const appYear = new Date(app.submittedDate).getFullYear();
//               return appYear === parseInt(selectedYear);
//             })
//           );
//         }
//       } else {
//         console.error('Unexpected data format:', response.data);
//         setApplications([]);
//         setFilteredApplications([]);
//       }
//     } catch (error) {
//       console.error('Error fetching applications:', error);
//       setApplications([]);
//       setFilteredApplications([]);
//     }
//   };
//   fetchApplications();
// }, [selectedYear]);
  
  

//   const handleClose = () => setShowModal(false);

//   const handleShow = (appId, reviewer, type) => {
//     const app = applications.find(app => app.app_ID === appId);
//     setCurrentApp(app);
//     setCurrentReviewer({
//       name: reviewer.name,
//       email: reviewer.email,
//       affiliation: reviewer.affiliation,
//       type: type,  // 'Reviewer One' or 'Reviewer Two'
//     });
  
//     // Generate the dynamic link based on the reviewer type (Reviewer One, Reviewer Two, or Reviewer Three)
// let reviewerPath = '';
// if (type === 'Reviewer One') reviewerPath = 'reviewer1';
// else if (type === 'Reviewer Two') reviewerPath = 'reviewer2';
// else if (type === 'Reviewer Three') reviewerPath = 'reviewer3';

// const reviewerLink = `${window.location.origin}/${reviewerPath}?app_ID=${appId}`;

//     // Set the email body with the dynamic link and placeholders for name and project title
//     setEmailBody(`
//       Dear ${reviewer.name},<br /><br />
//       We hope this message finds you well.<br /><br />
//       We extend our sincere gratitude to those of you who have supported our research grant evaluation process in the past. Your invaluable insights have significantly contributed to the advancement of research at our university.<br /><br />
//       We're excited to announce that this year, we've once again opened applications for our annual multidisciplinary research grant scheme. This program aims to foster collaborative research projects across different faculties, addressing diverse and critical research questions with the potential for significant impact.<br /><br />
//       We're would like to invite you to serve as an evaluator for a multidisciplinary research grant proposal titled "${app.projectTitle}". Your expertise in the field of this grant application would be invaluable in assessing the scientific merit, innovation, and feasibility of this project. We kindly request that you review the attached documents and provide your expert opinion using the enclosed evaluation template.<br /><br />
//       The following documents can be downloaded from our portal (you can enter the portal using the link below) by clicking 'More Details' button:<br />
//       1. Project Proposal<br />
//       2. Project Budget<br />
//       3. Principal Investigator's Curriculum Vitae<br />
//       4. Combined Curriculum Vitae of Co-Investigators<br /><br />
//       We understand your time is valuable, and we would be grateful if you could submit your review within the next 14 days. If you encounter any conflicts of interest or are unable to undertake this review, please let us know promptly by email.<br /><br />
//       Should you have any questions or require further information, please do not hesitate to contact me directly.<br /><br />
//       Thank you in advance for considering this request and for your continued support in advancing impactful research.<br /><br />
//       Please evaluate the Application using the evaluation form given in the following Link: ${reviewerLink}<br /><br />
//       With best regards<br><br />
//       Janaka<br><br />
//       <span style="color: blue;">Prof. Janaka Ekanayake</span><br><br />
//       <span style="color: blue;">BScEng(Hons), PhD, FIEEE (USA), FIET (UK), FNAS (SL), FIESL, CEng</span><br><br />
//       <span style="color: blue;">Senior Professor and Chair of Electrical and Electronic Engineering</span><br><br />
//       <span style="color: blue;">Director, University Research Council</span><br><br />
//       <span style="color: blue;">University of Peradeniya, Sri Lanka</span><br><br />
//       <span style="color: blue;">Tel: +94 777146979</span><br><br />
//       <span style="color: blue;">Email: <a href="mailto:EkanayakeJ@eng.pdn.ac.lk" style="color: blue;">EkanayakeJ@eng.pdn.ac.lk</a></span>
//     `);
    
//     setShowModal(true);
//   };
  
  
//   const handleSendEmail = async (event) => {
//   event.preventDefault();
//   setLoading(true); // Start spinner

//   try {
//     // Determine endpoint based on reviewer type
//     let endpoint = '';
//     if (currentReviewer.type === "Reviewer One") {
//       endpoint = `${API_BASE_URL}/SaveReviewer1.php`;
//     } else if (currentReviewer.type === "Reviewer Two") {
//       endpoint = `${API_BASE_URL}/SaveReviewer2.php`;
//     } else if (currentReviewer.type === "Reviewer Three") {
//       endpoint = `${API_BASE_URL}/SaveReviewer3.php`;
//     }


//     // Save reviewer details
//     const saveResponse = await axios.post(endpoint, {
//       app_ID: currentApp.app_ID,
//       reviewerEmail: currentReviewer.email,
//       reviewerName: currentReviewer.name,
//       reviewerAffiliation: currentReviewer.affiliation,
//     }, {
//       headers: { "Content-Type": "application/x-www-form-urlencoded" },
//       transformRequest: [(data) => {
//         const params = new URLSearchParams();
//         for (const key in data) {
//           params.append(key, data[key]);
//         }
//         return params;
//       }],
//     });

//     if (saveResponse.data.status === "success") {
//       console.log("Reviewer details saved successfully");

//       // Send email
//       const emailResponse = await axios.post(`${API_BASE_URL}/Email.php`, {
//         email: currentReviewer.email,
//         subject: `INVITATION TO REVIEW PROJECT: ${currentApp.projectTitle}`,
//         message: emailBody, // Email body containing the dynamic link
//       });

//       if (emailResponse.data.status === "success") {
//         alert("Email sent successfully!");
//         console.log("Email response:", emailResponse.data);
//       } else {
//         alert(`Failed to send email: ${emailResponse.data.message}`);
//         console.error("Email error:", emailResponse.data.message);
//       }
//     } else {
//       alert("There was an error saving reviewer details. Please try again.");
//     }
//   } catch (error) {
//     console.error("Error during the process:", error);
//     alert("An error occurred. Please try again.");
//   } finally {
//     setLoading(false); // Stop spinner
//   }
// };

  
//   const handleView = async (app_ID, reviewerType) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/DownloadEvaluationReport.php?app_ID=${app_ID}&reviewerType=${reviewerType}`, {
//         responseType: 'blob',
//       });
  
//       if (response.data.size === 0) {
//         alert("File not found.");
//         return;
//       }
  
//       // Determine file type from response headers
//       const contentType = response.headers['content-type'];
//       let fileExtension = 'pdf'; // Default to PDF
  
//       if (contentType.includes('word') || contentType.includes('msword')) {
//         fileExtension = 'docx';
//       }
  
//       // Create a download link
//       const blob = new Blob([response.data], { type: contentType });
//       const link = document.createElement('a');
//       link.href = URL.createObjectURL(blob);
//       link.download = `${app_ID}_EvaluationReport.${fileExtension}`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (error) {
//       console.error("Error downloading file:", error);
//       alert("File not found.");
//     }
//   };

//   const checkFileExistence = async (app_ID, fileType) => {
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/CheckFileExistence.php?app_ID=${app_ID}&fileType=${fileType}`
//       );
//       return response.data.exists;
//     } catch (error) {
//       console.error("Error checking file existence:", error);
//       return false;
//     }
//   };

//   useEffect(() => {
//     const fetchFileStatuses = async () => {
//       const statusMap = {};

//       for (const app of applications) {
//         statusMap[app.app_ID] = {
//           reviewer_one: await checkFileExistence(app.app_ID, "reviewer_one"),
//           reviewer_two: await checkFileExistence(app.app_ID, "reviewer_two"),
//           reviewer_three: await checkFileExistence(app.app_ID, "reviewer_three"),
//         };
//       }

//       setFileStatus(statusMap);
//     };

//     if (applications.length > 0) {
//       fetchFileStatuses();
//     }
//   }, [applications]);

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Send Reviewers</h1>
//       <div className="year-filter">
//   <label htmlFor="year-select">Year: </label>
//   <select
//     id="year-select"
//     value={selectedYear}
//     onChange={(e) => setSelectedYear(e.target.value)}
//     className="year-select"
//   >
//     <option value="">Select Year</option>
//     {years.map((year) => (
//       <option key={year} value={year}>
//         {year}
//       </option>
//     ))}
//   </select>
// </div>
//       <Table striped bordered hover>
//         <thead>
//         <tr>
//           <th colSpan={5}>
//           <label>Approved Applications ( By Dean)</label>
//           </th>
//           </tr>
          
//           <tr>
//             <th className="title">Application ID</th>
//             <th className="title">Project Title</th>
//             <th className="title">Submitted Date</th>
//             <th className="title" colSpan={3}>Reviewers</th>
//           </tr>
//           <tr>
//             <th colSpan={3}></th>
//             <th className="title">Reviewer One</th>
//             <th className="title">Reviewer Two</th>
//             <th className="title">Reviewer Three</th>
//           </tr>
//         </thead>
//         <tbody>
//           {Array.isArray(filteredApplications) && filteredApplications.length > 0 ? (
//             filteredApplications.map((app) => (
//               <tr key={app.app_ID}>
//                 <td>{app.app_ID}</td>
//                 <td>{app.projectTitle}</td>
//                 <td>{app.submittedDate}</td>
//                 <td>
//                   <div>
//                     <label className="Reviewer">{app.reviewer1Name}</label>
//                   </div>
//                   {app.reviewer1_mark ? null : (
//                     <button
//                       className="Email-button"
//                       onClick={() =>
//                         handleShow(
//                           app.app_ID,
//                           {
//                             name: app.reviewer1Name,
//                             email: app.reviewer1Email,
//                             affiliation: app.reviewer1Affiliation,
//                           },
//                           "Reviewer One"
//                         )
//                       }
//                       style={{
//                         backgroundColor: app.reviewer1EmailSent ? "#6F42C1" : "#052659",
//                         color: "#fff",
//                       }}
//                     >
//                       Send Email
//                     </button>
//                   )}
//                   <br />
//                   <div className="marks-container">
//                     <label className="marks-label">
//                       Mark: {app.reviewer1_mark || "N/A"}
//                     </label>
//                     {fileStatus[app.app_ID]?.reviewer_one ? (
//                       <button
//                         className="EvaluationR-button"
//                         onClick={() => handleView(app.app_ID, "reviewer_one")}
//                       >
//                         Evaluation Report
//                       </button>
//                     ) : (
//                       <button className="NotAvailable-button">Report : N/A</button>
//                     )}
//                   </div>
//                 </td>
//                 <td>
//                   <div>
//                     <label className="Reviewer">{app.reviewer2Name}</label>
//                   </div>
//                   {app.reviewer2_mark ? null : (
//                     <button
//                       className="Email-button"
//                       onClick={() =>
//                         handleShow(
//                           app.app_ID,
//                           {
//                             name: app.reviewer2Name,
//                             email: app.reviewer2Email,
//                             affiliation: app.reviewer2Affiliation,
//                           },
//                           "Reviewer Two"
//                         )
//                       }
//                       style={{
//                         backgroundColor: app.reviewer2EmailSent ? "#6F42C1" : "#052659",
//                         color: "#fff",
//                       }}
//                     >
//                       Send Email
//                     </button>
//                   )}
//                   <br />
//                   <div className="marks-container">
//                     <label className="marks-label">
//                       Mark: {app.reviewer2_mark || "N/A"}
//                     </label>
//                     {fileStatus[app.app_ID]?.reviewer_two ? (
//                       <button
//                         className="EvaluationR-button"
//                         onClick={() => handleView(app.app_ID, "reviewer_two")}
//                       >
//                         Evaluation Report
//                       </button>
//                     ) : (
//                       <button className="NotAvailable-button">Report : N/A</button>
//                     )}
//                   </div>
//                 </td>
//                 <td>
//   <div>
//     <label className="Reviewer">{app.reviewer3Name}</label>
//   </div>
//   {app.reviewer3_mark ? null : (
//     <button
//       className="Email-button"
//       onClick={() =>
//         handleShow(
//           app.app_ID,
//           {
//             name: app.reviewer3Name,
//             email: app.reviewer3Email,
//             affiliation: app.reviewer3Affiliation,
//           },
//           "Reviewer Three"
//         )
//       }
//       style={{
//         backgroundColor: app.reviewer3EmailSent ? "#6F42C1" : "#052659",
//         color: "#fff",
//       }}
//     >
//       Send Email
//     </button>
//   )}
//   <br />
//   <div className="marks-container">
//     <label className="marks-label">
//       Mark: {app.reviewer3_mark || "N/A"}
//     </label>
//     {fileStatus[app.app_ID]?.reviewer_three ? (
//       <button
//         className="EvaluationR-button"
//         onClick={() => handleView(app.app_ID, "reviewer_three")}
//       >
//         Evaluation Report
//       </button>
//     ) : (
//       <button className="NotAvailable-button">Report : N/A</button>
//     )}
//   </div>
// </td>

//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="5">No applications found.</td>
//             </tr>
//           )}
//         </tbody>
//       </Table>

//       <Modal show={showModal} onHide={handleClose} size='lg'>
//         <Modal.Header closeButton>
//           <Modal.Title>Send Email to {currentReviewer.name}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="formProjectTitle">
//               <Form.Label>Project Title</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={currentApp ? currentApp.projectTitle : ''}
//                 readOnly
//               />
//             </Form.Group>

//             <Form.Group controlId="formReviewerName">
//               <Form.Label>Reviewer Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={currentReviewer.name}
//                 onChange={(e) => {
//                   const updatedName = e.target.value;
//                   setCurrentReviewer({ ...currentReviewer, name: updatedName });
//                 }}
//               />
//             </Form.Group>

//             <Form.Group controlId="formReviewerEmail">
//               <Form.Label>Reviewer Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 value={currentReviewer.email}
//                 onChange={(e) => setCurrentReviewer({ ...currentReviewer, email: e.target.value })}
//               />
//             </Form.Group>

//             <Form.Group controlId="formReviewerAffiliation">
//               <Form.Label>Reviewer Affiliation</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={currentReviewer.affiliation}
//                 onChange={(e) => setCurrentReviewer({ ...currentReviewer, affiliation: e.target.value })}
//               />
//             </Form.Group>

//             <Form.Group controlId="formEmailBody">
//               <Form.Label>Email Body</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 value={emailBody}
//                 onChange={(e) => setEmailBody(e.target.value)}
//                 rows={12}
//               />
//             </Form.Group>

//             <Form.Group controlId="formReviewerLink">
//               <Form.Label>Review Link</Form.Label>
//               <div style={{ color: 'black', padding: '8px', backgroundColor: '#f8f9fa', border: '1px solid #ced4da', borderRadius: '4px',textDecoration: 'none' }}>
//                 {currentApp && currentReviewer.type ? (
//                   <a href={`${window.location.origin}/${currentReviewer.type === 'Reviewer One' ? 'reviewer1' : 'reviewer2'}?app_ID=${currentApp.app_ID}`} target="_blank" rel="noopener noreferrer">
//                     {`${window.location.origin}/${currentReviewer.type === 'Reviewer One' ? 'reviewer1' : 'reviewer2'}?app_ID=${currentApp.app_ID}`}
//                   </a>
//                 ) : (
//                   <span>No link available</span>
//                 )}
//               </div>
//             </Form.Group>
//           </Form>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose}>Cancel</Button>
//           <Button variant="primary" onClick={handleSendEmail} disabled={loading}>
//             {loading ? (
//               <>
//                 <Spinner animation="border" size="sm" /> Sending...
//               </>
//             ) : (
//               "Send"
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import Navbar from '../../Components/Navbar';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import '../Secretary/Table.css';
import { API_BASE_URL } from '../../config';
import { Button, Spinner } from "react-bootstrap";

export default function SendReviewers() {
  const [applications, setApplications] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentApp, setCurrentApp] = useState(null);
  const [currentReviewer, setCurrentReviewer] = useState({});
  const [emailBody, setEmailBody] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fileStatus, setFileStatus] = useState({});
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");

  const currentYear = new Date().getFullYear();
  const startYear = 2024;
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  ).reverse();

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/SendReviewers.php`);
        console.log('Fetched applications:', response.data);
        if (Array.isArray(response.data)) {
          setApplications(response.data);
          if (selectedYear === "") {
            setFilteredApplications(response.data);
          } else {
            setFilteredApplications(
              response.data.filter((app) => {
                const appYear = new Date(app.submittedDate).getFullYear();
                return appYear === parseInt(selectedYear);
              })
            );
          }
        } else {
          console.error('Unexpected data format:', response.data);
          setApplications([]);
          setFilteredApplications([]);
        }
      } catch (error) {
        console.error('Error fetching applications:', error);
        setApplications([]);
        setFilteredApplications([]);
      }
    };
    fetchApplications();
  }, [selectedYear]);

  const handleClose = () => setShowModal(false);

  const handleShow = (appId, reviewer, type) => {
    const app = applications.find(app => app.app_ID === appId);
    setCurrentApp(app);
    setCurrentReviewer({
      name: reviewer.name,
      email: reviewer.email,
      affiliation: reviewer.affiliation,
      type: type,
    });

    let reviewerPath = '';
    if (type === 'Reviewer One') reviewerPath = 'reviewer1';
    else if (type === 'Reviewer Two') reviewerPath = 'reviewer2';
    else if (type === 'Reviewer Three') reviewerPath = 'reviewer3';

    const reviewerLink = `${window.location.origin}/${reviewerPath}?app_ID=${appId}`;

    setEmailBody(`
      Dear ${reviewer.name},<br><br>
      We hope this message finds you well.<br><br>
      We extend our sincere gratitude to those of you who have supported our research grant evaluation process in the past. Your invaluable insights have significantly contributed to the advancement of research at our university.<br><br>
      We're excited to announce that this year, we've once again opened applications for our annual multidisciplinary research grant scheme. This program aims to foster collaborative research projects across different faculties, addressing diverse and critical research questions with the potential for significant impact.<br><br>
      We're would like to invite you to serve as an evaluator for a multidisciplinary research grant proposal titled "${app.projectTitle}". Your expertise in the field of this grant application would be invaluable in assessing the scientific merit, innovation, and feasibility of this project. We kindly request that you review the attached documents and provide your expert opinion using the enclosed evaluation template.<br><br>
      The following documents can be downloaded from our portal (you can enter the portal using the link below) by clicking 'More Details' button:<br>
      1. Project Proposal<br>
      2. Project Budget<br>
      3. Principal Investigator's Curriculum Vitae<br>
      4. Combined Curriculum Vitae of Co-Investigators<br><br>
      We understand your time is valuable, and we would be grateful if you could submit your review within the next 14 days. If you encounter any conflicts of interest or are unable to undertake this review, please let us know promptly by email.<br><br>
      Should you have any questions or require further information, please do not hesitate to contact me directly.<br><br>
      Thank you in advance for considering this request and for your continued support in advancing impactful research.<br><br>
      Please evaluate the Application using the evaluation form given in the following Link: <a href="${reviewerLink}" target="_blank">${reviewerLink}</a><br><br>
      With best regards<br><br>
      Janaka<br><br>
      <span style="color: blue;">Prof. Janaka Ekanayake</span><br><br>
      <span style="color: blue;">BScEng(Hons), PhD, FIEEE (USA), FIET (UK), FNAS (SL), FIESL, CEng</span><br><br>
      <span style="color: blue;">Senior Professor and Chair of Electrical and Electronic Engineering</span><br><br>
      <span style="color: blue;">Director, University Research Council</span><br><br>
      <span style="color: blue;">University of Peradeniya, Sri Lanka</span><br><br>
      <span style="color: blue;">Tel: +94 777146979</span><br><br>
      <span style="color: blue;">Email: <a href="mailto:EkanayakeJ@eng.pdn.ac.lk" style="color: blue;">EkanayakeJ@eng.pdn.ac.lk</a></span>
    `);

    setShowModal(true);
  };

  const handleSendEmail = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      let endpoint = '';
      if (currentReviewer.type === "Reviewer One") {
        endpoint = `${API_BASE_URL}/SaveReviewer1.php`;
      } else if (currentReviewer.type === "Reviewer Two") {
        endpoint = `${API_BASE_URL}/SaveReviewer2.php`;
      } else if (currentReviewer.type === "Reviewer Three") {
        endpoint = `${API_BASE_URL}/SaveReviewer3.php`;
      }

      const saveResponse = await axios.post(endpoint, {
        app_ID: currentApp.app_ID,
        reviewerEmail: currentReviewer.email,
        reviewerName: currentReviewer.name,
        reviewerAffiliation: currentReviewer.affiliation,
      }, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        transformRequest: [(data) => {
          const params = new URLSearchParams();
          for (const key in data) {
            params.append(key, data[key]);
          }
          return params;
        }],
      });

      if (saveResponse.data.status === "success") {
        console.log("Reviewer details saved successfully");

        const emailResponse = await axios.post(`${API_BASE_URL}/Email.php`, {
          email: currentReviewer.email,
          subject: `INVITATION TO REVIEW PROJECT: ${currentApp.projectTitle}`,
          message: emailBody,
        });

        if (emailResponse.data.status === "success") {
          alert("Email sent successfully!");
          console.log("Email response:", emailResponse.data);
        } else {
          alert(`Failed to send email: ${emailResponse.data.message}`);
          console.error("Email error:", emailResponse.data.message);
        }
      } else {
        alert("There was an error saving reviewer details. Please try again.");
      }
    } catch (error) {
      console.error("Error during the process:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (app_ID, reviewerType) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/DownloadEvaluationReport.php?app_ID=${app_ID}&reviewerType=${reviewerType}`, {
        responseType: 'blob',
      });

      if (response.data.size === 0) {
        alert("File not found.");
        return;
      }

      const contentType = response.headers['content-type'];
      let fileExtension = 'pdf';
      if (contentType.includes('word') || contentType.includes('msword')) {
        fileExtension = 'docx';
      }

      const blob = new Blob([response.data], { type: contentType });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${app_ID}_EvaluationReport.${fileExtension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("File not found.");
    }
  };

  const checkFileExistence = async (app_ID, fileType) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CheckFileExistence.php?app_ID=${app_ID}&fileType=${fileType}`
      );
      return response.data.exists;
    } catch (error) {
      console.error("Error checking file existence:", error);
      return false;
    }
  };

  useEffect(() => {
    const fetchFileStatuses = async () => {
      const statusMap = {};

      for (const app of applications) {
        statusMap[app.app_ID] = {
          reviewer_one: await checkFileExistence(app.app_ID, "reviewer_one"),
          reviewer_two: await checkFileExistence(app.app_ID, "reviewer_two"),
          reviewer_three: await checkFileExistence(app.app_ID, "reviewer_three"),
        };
      }

      setFileStatus(statusMap);
    };

    if (applications.length > 0) {
      fetchFileStatuses();
    }
  }, [applications]);

  // Handle contentEditable changes
  const handleEmailBodyChange = (e) => {
    setEmailBody(e.target.innerHTML);
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">Send Reviewers</h1>
      <div className="year-filter">
        <label htmlFor="year-select">Year: </label>
        <select
          id="year-select"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="year-select"
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th colSpan={6}>
              <label>Approved Applications ( By Dean)</label>
            </th>
          </tr>
          <tr>
            <th className="title">Application ID</th>
            <th className="title">Project Title</th>
            <th className="title">Submitted Date</th>
            <th className="title">Reviewer One</th>
            <th className="title">Reviewer Two</th>
            <th className="title">Reviewer Three</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(filteredApplications) && filteredApplications.length > 0 ? (
            filteredApplications.map((app) => (
              <tr key={app.app_ID}>
                <td>{`${app.app_ID}_${new Date().getFullYear()}`}</td>
                <td>{app.projectTitle}</td>
                <td>{app.submittedDate}</td>
                <td>
                  <div>
                    <label className="Reviewer">{app.reviewer1Name}</label>
                  </div>
                  {app.reviewer1_mark ? null : (
                    <button
                      className="Email-button"
                      onClick={() =>
                        handleShow(
                          app.app_ID,
                          {
                            name: app.reviewer1Name,
                            email: app.reviewer1Email,
                            affiliation: app.reviewer1Affiliation,
                          },
                          "Reviewer One"
                        )
                      }
                      style={{
                        backgroundColor: app.reviewer1EmailSent ? "#6F42C1" : "#052659",
                        color: "#fff",
                      }}
                    >
                      Send Email
                    </button>
                  )}
                  <br />
                  <div className="marks-container">
                    <label className="marks-label">
                      Mark: {app.reviewer1_mark || "N/A"}
                    </label>
                    {fileStatus[app.app_ID]?.reviewer_one ? (
                      <button
                        className="EvaluationR-button"
                        onClick={() => handleView(app.app_ID, "reviewer_one")}
                      >
                        Evaluation Report
                      </button>
                    ) : (
                      <button className="NotAvailable-button">Report : N/A</button>
                    )}
                  </div>
                </td>
                <td>
                  <div>
                    <label className="Reviewer">{app.reviewer2Name}</label>
                  </div>
                  {app.reviewer2_mark ? null : (
                    <button
                      className="Email-button"
                      onClick={() =>
                        handleShow(
                          app.app_ID,
                          {
                            name: app.reviewer2Name,
                            email: app.reviewer2Email,
                            affiliation: app.reviewer2Affiliation,
                          },
                          "Reviewer Two"
                        )
                      }
                      style={{
                        backgroundColor: app.reviewer2EmailSent ? "#6F42C1" : "#052659",
                        color: "#fff",
                      }}
                    >
                      Send Email
                    </button>
                  )}
                  <br />
                  <div className="marks-container">
                    <label className="marks-label">
                      Mark: {app.reviewer2_mark || "N/A"}
                    </label>
                    {fileStatus[app.app_ID]?.reviewer_two ? (
                      <button
                        className="EvaluationR-button"
                        onClick={() => handleView(app.app_ID, "reviewer_two")}
                      >
                        Evaluation Report
                      </button>
                    ) : (
                      <button className="NotAvailable-button">Report : N/A</button>
                    )}
                  </div>
                </td>
                <td>
                  <div>
                    <label className="Reviewer">{app.reviewer3Name}</label>
                  </div>
                  {app.reviewer3_mark ? null : (
                    <button
                      className="Email-button"
                      onClick={() =>
                        handleShow(
                          app.app_ID,
                          {
                            name: app.reviewer3Name,
                            email: app.reviewer3Email,
                            affiliation: app.reviewer3Affiliation,
                          },
                          "Reviewer Three"
                        )
                      }
                      style={{
                        backgroundColor: app.reviewer3EmailSent ? "#6F42C1" : "#052659",
                        color: "#fff",
                      }}
                    >
                      Send Email
                    </button>
                  )}
                  <br />
                  <div className="marks-container">
                    <label className="marks-label">
                      Mark: {app.reviewer3_mark || "N/A"}
                    </label>
                    {fileStatus[app.app_ID]?.reviewer_three ? (
                      <button
                        className="EvaluationR-button"
                        onClick={() => handleView(app.app_ID, "reviewer_three")}
                      >
                        Evaluation Report
                      </button>
                    ) : (
                      <button className="NotAvailable-button">Report : N/A</button>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">No applications found.</td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleClose} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Send Email to {currentReviewer.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formProjectTitle">
              <Form.Label>Project Title</Form.Label>
              <Form.Control
                type="text"
                value={currentApp ? currentApp.projectTitle : ''}
                readOnly
              />
            </Form.Group>
            <Form.Group controlId="formReviewerName">
              <Form.Label>Reviewer Name</Form.Label>
              <Form.Control
                type="text"
                value={currentReviewer.name}
                onChange={(e) => {
                  const updatedName = e.target.value;
                  setCurrentReviewer({ ...currentReviewer, name: updatedName });
                }}
              />
            </Form.Group>
            <Form.Group controlId="formReviewerEmail">
              <Form.Label>Reviewer Email</Form.Label>
              <Form.Control
                type="email"
                value={currentReviewer.email}
                onChange={(e) => setCurrentReviewer({ ...currentReviewer, email: e.target.value })}
              />
            </Form.Group>
            <Form.Group controlId="formReviewerAffiliation">
              <Form.Label>Reviewer Affiliation</Form.Label>
              <Form.Control
                type="text"
                value={currentReviewer.affiliation}
                onChange={(e) => setCurrentReviewer({ ...currentReviewer, affiliation: e.target.value })}
              />
            </Form.Group>
            <Form.Group controlId="formEmailBody">
              <Form.Label>Email Body</Form.Label>
              <div
                className="email-body-preview"
                contentEditable="true"
                onInput={handleEmailBodyChange}
                dangerouslySetInnerHTML={{ __html: emailBody }}
                style={{
                  border: '1px solid #ced4da',
                  padding: '10px',
                  minHeight: '150px',
                  backgroundColor: '#fff',
                  borderRadius: '4px',
                  outline: 'none',
                }}
              />
            </Form.Group>
            <Form.Group controlId="formReviewerLink">
              <Form.Label>Review Link</Form.Label>
              <div style={{ color: 'black', padding: '8px', backgroundColor: '#f8f9fa', border: '1px solid #ced4da', borderRadius: '4px', textDecoration: 'none' }}>
                {currentApp && currentReviewer.type ? (
                  <a href={`${window.location.origin}/${currentReviewer.type === 'Reviewer One' ? 'reviewer1' : currentReviewer.type === 'Reviewer Two' ? 'reviewer2' : 'reviewer3'}?app_ID=${currentApp.app_ID}`} target="_blank" rel="noopener noreferrer">
                    {`${window.location.origin}/${currentReviewer.type === 'Reviewer One' ? 'reviewer1' : currentReviewer.type === 'Reviewer Two' ? 'reviewer2' : 'reviewer3'}?app_ID=${currentApp.app_ID}`}
                  </a>
                ) : (
                  <span>No link available</span>
                )}
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" onClick={handleSendEmail} disabled={loading}>
            {loading ? (
              <>
                <Spinner animation="border" size="sm" /> Sending...
              </>
            ) : (
              "Send"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}













// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import Table from 'react-bootstrap/Table';
// import Navbar from '../../Components/Navbar';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import '../Secretary/Table.css';

// export default function SendReviewers() {
//   const [applications, setApplications] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [currentApp, setCurrentApp] = useState(null);
//   const [currentReviewer, setCurrentReviewer] = useState({});
//   const [emailBody, setEmailBody] = useState('');
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchApplications = async () => {
//       try {
//         const response = await axios.get('/SendReviewers.php');
//         console.log('Fetched applications:', response.data); // Debug log
    
//         // Ensure response is an array
//         if (Array.isArray(response.data)) {
//           setApplications(response.data);
//         } else {
//           console.error('Unexpected data format:', response.data);
//           setApplications([]); // Fallback to an empty array
//         }
//       } catch (error) {
//         console.error('Error fetching applications:', error);
//         setApplications([]); // Ensure applications is always an array
//       }
//     };
    
//     fetchApplications();
//   }, []);
  

//   const handleClose = () => setShowModal(false);

//   const handleShow = (appId, reviewer, type) => {
//     const app = applications.find(app => app.app_ID === appId);
//     setCurrentApp(app);
//     setCurrentReviewer({
//       name: reviewer.name,
//       email: reviewer.email,
//       affiliation: reviewer.affiliation,
//       type: type,  // 'Reviewer One' or 'Reviewer Two'
//     });
  
//     // Generate the dynamic link based on the reviewer type (Reviewer One or Reviewer Two)
//     const reviewerLink = `${window.location.origin}/${type === 'Reviewer One' ? 'reviewer1' : 'reviewer2'}?app_ID=${appId}`;
  
//     // Set the email body with the dynamic link
//     setEmailBody(
//       `<span style="color: black;">Please review at the following link:</span>\n` +
//       `<a href="${reviewerLink}" target="_blank">${reviewerLink}</a>`
//     );
  
//     setShowModal(true);
//   };
  

  
//   const handleSendEmail = async (event) => {
//     event.preventDefault();
  
//     try {
//       // Save reviewer details
//       const endpoint = currentReviewer.type === 'Reviewer One' ? '/SaveReviewer1.php' : '/SaveReviewer2.php';
//       const saveResponse = await axios.post(endpoint, {
//         app_ID: currentApp.app_ID,
//         reviewerEmail: currentReviewer.email,
//         reviewerName: currentReviewer.name,
//         reviewerAffiliation: currentReviewer.affiliation,
//       }, {
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         transformRequest: [(data) => {
//           const params = new URLSearchParams();
//           for (const key in data) {
//             params.append(key, data[key]);
//           }
//           return params;
//         }],
//       });
  
//       if (saveResponse.data.status === "success") {
//         console.log("Reviewer details saved successfully");
  
//         // Send email
//         const emailResponse = await axios.post('Email.php', {
//           email: currentReviewer.email,
//           subject: `Invitation to Review Project: ${currentApp.projectTitle}`,
//           message: emailBody, // Email body containing the dynamic link
//         });
  
//         if (emailResponse.data.status === "success") {
//           alert("Email sent successfully!");
//           console.log("Email response:", emailResponse.data);
//         } else {
//           alert(`Failed to send email: ${emailResponse.data.message}`);
//           console.error("Email error:", emailResponse.data.message);
//         }
//       } else {
//         alert('There was an error saving reviewer details. Please try again.');
//       }
//     } catch (error) {
//       console.error("Error during the process:", error);
//       alert('An error occurred. Please try again.');
//     }
//   };
  
  

  
//   const handleView = (id, reportType) => {
//     navigate(`/reviewerOne?app_ID=${id}&reportType=${reportType}`);
//   };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Send Reviewers</h1>
//       <Table striped bordered hover>
//         <thead>
//         <tr>
//           <th colSpan={5}>
//           <label>Approved Applications ( By Dean)</label>
//           </th>
//           </tr>
          
//           <tr>
//             <th className="title">Application ID</th>
//             <th className="title">Project Title</th>
//             <th className="title">Submitted Date</th>
//             <th className="title" colSpan={2}>Reviewers</th>
//           </tr>
//           <tr>
//             <th colSpan={3}></th>
//             <th className="title">Reviewer One</th>
//             <th className="title">Reviewer Two</th>
//           </tr>
//         </thead>
//         <tbody>
//   {Array.isArray(applications) && applications.length > 0 ? (
//     applications.map((app) => (
//       <tr key={app.app_ID}>
//         <td>{app.app_ID}</td>
//         <td>{app.projectTitle}</td>
//         <td>{app.submittedDate}</td>
//         <td>
//           <div>
//             <label className="Reviewer">{app.reviewer1Name}</label>
//           </div>
//           {app.reviewer1_mark ? null : (
//             <button
//               className="Email-button"
//               onClick={() =>
//                 handleShow(app.app_ID, {
//                   name: app.reviewer1Name,
//                   email: app.reviewer1Email,
//                   affiliation: app.reviewer1Affiliation,
//                 }, 'Reviewer One')
//               }
//             >
//               Send Email
//             </button>
//           )}
//           <br />
//           <div className="marks-container">
//             <label className="marks-label">Mark: {app.reviewer1_mark || 'N/A'}</label>
//             <button className="view-button" onClick={() => handleView(app.app_ID, 'mid')}>View</button>
//           </div>
//         </td>
//         <td>
//           <div>
//             <label className="Reviewer">{app.reviewer2Name}</label>
//           </div>
//           {app.reviewer2_mark ? null : (
//             <button
//               className="Email-button"
//               onClick={() =>
//                 handleShow(app.app_ID, {
//                   name: app.reviewer2Name,
//                   email: app.reviewer2Email,
//                   affiliation: app.reviewer2Affiliation,
//                 }, 'Reviewer Two')
//               }
//             >
//               Send Email
//             </button>
//           )}
//           <br />
//           <div className="marks-container">
//             <label className="marks-label">Mark: {app.reviewer2_mark || 'N/A'}</label>
//             <button className="view-button" onClick={() => handleView(app.app_ID, 'end')}>View</button>
//           </div>
//         </td>
//       </tr>
//     ))
//   ) : (
//     <tr>
//       <td colSpan="5">No applications found.</td>
//     </tr>
//   )}
// </tbody>



//       </Table>

//       <Modal show={showModal} onHide={handleClose}>
//         <Modal.Header closeButton>
//           <Modal.Title>Send Email to {currentReviewer.name}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="formProjectTitle">
//               <Form.Label>Project Title</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={currentApp ? currentApp.projectTitle : ''}
//                 readOnly
//               />
//             </Form.Group>
//             <Form.Group controlId="formReviewerName">
//               <Form.Label>Reviewer Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={currentReviewer.name}
//                 onChange={(e) => setCurrentReviewer({ ...currentReviewer, name: e.target.value })}
//               />
//             </Form.Group>
//             <Form.Group controlId="formReviewerEmail">
//               <Form.Label>Reviewer Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 value={currentReviewer.email}
//                 onChange={(e) => setCurrentReviewer({ ...currentReviewer, email: e.target.value })}
//               />
//             </Form.Group>
//             <Form.Group controlId="formReviewerAffiliation">
//               <Form.Label>Reviewer Affiliation</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={currentReviewer.affiliation}
//                 onChange={(e) => setCurrentReviewer({ ...currentReviewer, affiliation: e.target.value })}
//               />
//             </Form.Group>
//             <Form.Group controlId="formEmailBody">
//               <Form.Label>Email Body</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={5}
//                 value={emailBody}
//                 onChange={(e) => setEmailBody(e.target.value)}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose}>Cancel</Button>
//           <Button variant="primary" onClick={handleSendEmail}>Send</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import Table from 'react-bootstrap/Table';
// import Navbar from '../../Components/Navbar';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import '../Secretary/Table.css';

// export default function SendReviewers() {
//   const [applications, setApplications] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [currentApp, setCurrentApp] = useState(null);
//   const [currentReviewer, setCurrentReviewer] = useState({});
//   const [emailBody, setEmailBody] = useState('');
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchApplications = async () => {
//       try {
//         const response = await axios.get('/SendReviewers.php');
//         setApplications(response.data);
//       } catch (error) {
//         console.error('Error fetching applications:', error);
//       }
//     };
  
//     fetchApplications();
//   }, []);

//   const handleClose = () => setShowModal(false);

//   const handleShow = (appId, reviewer, type) => {
//     const app = applications.find(app => app.app_ID === appId);
//     setCurrentApp(app);
//     setCurrentReviewer(reviewer);
  
//     // Generate the dynamic link based on the reviewer type (Reviewer One or Reviewer Two)
//     const reviewerLink = `${window.location.origin}/${type === 'Reviewer One' ? 'reviewer1' : 'reviewer2'}?app_ID=${appId}`;
  
//     // Set the email body with the dynamic link, but make sure the link is uneditable
//     setEmailBody(
//       `Please review at the following link:\n` +
//       `<span contentEditable="false"><a href="${reviewerLink}" target="_blank">${reviewerLink}</a></span>`
//     );
  
//     setShowModal(true);
//   };

//   const handleEmailBodyChange = (e) => {
//     // Only allow editing of the non-link portion of the email body
//     setEmailBody(e.target.innerHTML);
//   };

//   const handleSendEmail = () => {
//     console.log(`Sending email to ${currentReviewer.email} for application ${currentApp.app_ID}`);
//     console.log(`Email body: ${emailBody}`);
//     handleClose();
//   };

//   const handleView = (id, reportType) => {
//     navigate(`/reviewerOne?app_ID=${id}&reportType=${reportType}`);
//   };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Send Reviewers</h1>
//       <Table striped bordered hover>
//         <thead>
//           <tr>
//             <th className="title">Application ID</th>
//             <th className="title">Project Title</th>
//             <th className="title">Submitted Date</th>
//             <th className="title" colSpan={2}>Reviewers</th>
//           </tr>
//           <tr>
//             <th colSpan={3}></th>
//             <th className="title">Reviewer One</th>
//             <th className="title">Reviewer Two</th>
//           </tr>
//         </thead>
//         <tbody>
//           {applications.map((app) => (
//             <tr key={app.app_ID}>
//               <td>{app.app_ID}</td>
//               <td>{app.projectTitle}</td>
//               <td>{app.submittedDate}</td>
//               <td>
//                 <div>
//                   <label className="Reviewer">{app.reviewer1Name}</label>
//                 </div>
//                 <button className="Email-button" onClick={() => handleShow(app.app_ID, { 
//                   name: app.reviewer1Name,
//                   email: app.reviewer1Email,
//                   affiliation: app.reviewer1Affiliation,
//                 }, 'Reviewer One')}>Send Email</button>
//                 <br />
//                 <button className="btn-rejected" onClick={() => handleView(app.app_ID, 'mid')}>Final Mark</button>
//                 <button className="view-button" onClick={() => handleView(app.app_ID, 'mid')}>View</button>
//               </td>
//               <td>
//                 <div>
//                   <label className="Reviewer">{app.reviewer2Name}</label>
//                 </div>
//                 <button className="Email-button" onClick={() => handleShow(app.app_ID, { 
//                   name: app.reviewer2Name,
//                   email: app.reviewer2Email,
//                   affiliation: app.reviewer2Affiliation, 
//                 }, 'Reviewer Two')}>Send Email</button>
//                 <br />
//                 <button className="btn-rejected" onClick={() => handleView(app.app_ID, 'end')}>Final Mark</button>
//                 <button className="view-button" onClick={() => handleView(app.app_ID, 'end')}>View</button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>

//       <Modal show={showModal} onHide={handleClose}>
//         <Modal.Header closeButton>
//           <Modal.Title>Send Email to {currentReviewer.name}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="formProjectTitle">
//               <Form.Label>Project Title</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={currentApp ? currentApp.projectTitle : ''}
//                 readOnly
//               />
//             </Form.Group>
//             <Form.Group controlId="formReviewerName">
//               <Form.Label>Reviewer Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={currentReviewer.name}
//                 readOnly
//               />
//             </Form.Group>
//             <Form.Group controlId="formReviewerEmail">
//               <Form.Label>Reviewer Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 value={currentReviewer.email}
//                 readOnly
//               />
//             </Form.Group>
//             <Form.Group controlId="formReviewerAffiliation">
//               <Form.Label>Reviewer Affiliation</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={currentReviewer.affiliation}
//                 readOnly
//               />
//             </Form.Group>
//             <Form.Group controlId="formEmailBody">
//               <Form.Label>Email Body</Form.Label>
//               <div
//                 style={{
//                   color: 'black',
//                   padding: '8px',
//                   backgroundColor: '#f8f9fa',
//                   border: '1px solid #ced4da',
//                   borderRadius: '4px',
//                 }}
//                 contentEditable
//                 onInput={handleEmailBodyChange}
//                 dangerouslySetInnerHTML={{ __html: emailBody }}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose}>Cancel</Button>
//           <Button variant="primary" onClick={handleSendEmail}>Send</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }
